var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConditions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.711,
    height: 36.544,
    viewBox: "0 0 28.711 36.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard_1_",
    "data-name": "clipboard (1)",
    transform: "translate(-47.037 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763",
    transform: "translate(47.037 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M72.094,4.788H68.788V3.309c0-.479-.522-.7-1-.7H65.221A3.891,3.891,0,0,0,61.349,0a3.959,3.959,0,0,0-3.872,2.61H54.954c-.479,0-.957.217-.957.7V4.788H50.691a3.7,3.7,0,0,0-3.654,3.524V33.238a3.5,3.5,0,0,0,3.654,3.306h21.4a3.5,3.5,0,0,0,3.654-3.306V8.312A3.7,3.7,0,0,0,72.094,4.788ZM55.737,4.353H58.13a.957.957,0,0,0,.827-.783,2.523,2.523,0,0,1,2.393-1.958A2.479,2.479,0,0,1,63.7,3.57a.957.957,0,0,0,.87.783h2.48v3.48H55.737ZM74.008,33.238A1.765,1.765,0,0,1,72.094,34.8h-21.4a1.765,1.765,0,0,1-1.914-1.566V8.312a1.958,1.958,0,0,1,1.914-1.784H54V8.747a.914.914,0,0,0,.957.827H67.787a.957.957,0,0,0,1-.827V6.528h3.306a1.958,1.958,0,0,1,1.914,1.784V33.238Z",
    transform: "translate(-47.037 0)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M104.81,230.539l-2.784,2.654-1.175-1.218a.87.87,0,0,0-1.218-.043.914.914,0,0,0,0,1.262l1.784,1.827a.783.783,0,0,0,.609.261.87.87,0,0,0,.609-.261l3.393-3.219c.017-.016.034-.033.05-.05a.827.827,0,0,0-.05-1.168A.87.87,0,0,0,104.81,230.539Z",
    transform: "translate(-95.022 -211.134)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M209.423,256.034H199.418a.87.87,0,0,0,0,1.74h10.005a.87.87,0,1,0,0-1.74Z",
    transform: "translate(-185.932 -234.715)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M209.423,172.442H199.418a.87.87,0,0,0,0,1.74h10.005a.87.87,0,1,0,0-1.74Z",
    transform: "translate(-185.932 -158.084)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M104.81,314.131l-2.784,2.654-1.175-1.218a.87.87,0,0,0-1.218-.043.914.914,0,0,0,0,1.262l1.784,1.827a.783.783,0,0,0,.609.261.87.87,0,0,0,.609-.261l3.393-3.219c.017-.016.034-.033.05-.05a.827.827,0,0,0-.05-1.168A.87.87,0,0,0,104.81,314.131Z",
    transform: "translate(-95.022 -287.766)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M209.423,339.626H199.418a.87.87,0,0,0,0,1.74h10.005a.87.87,0,1,0,0-1.74Z",
    transform: "translate(-185.932 -311.347)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M98.049,149.623h5.177a.849.849,0,0,0,.089,0,.827.827,0,0,0,.781-.87v-4.7a.87.87,0,0,0-.87-.87H98.049a.87.87,0,0,0-.87.87v4.7a.848.848,0,0,0,0,.089A.827.827,0,0,0,98.049,149.623Zm.87-4.7h3.437v2.958H98.919Z",
    transform: "translate(-93.003 -131.263)",
    fill: "#e1591f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConditions);
export default __webpack_public_path__ + "static/media/icon-conditions.cb19300f7dc82610d819d1388b831629.svg";
export { ForwardRef as ReactComponent };